import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { selectMyActiveCard, fetch as fetchMyCards, selectIsFetching as selectIsFetchingMyCards, selectIsLoaded as selectIsLoadedMyCards, selectIsFailure as selectIsFailureMyCards, selectIsToRefetch as selectIsToRefetchMyCards } from '../../../modules/mycards/resource';
import { useOfflineMean } from './useOfflineMean';
export const useShowSavedCreditCardCTA = ({
  order,
  sharingId
}) => {
  const dispatch = useDispatch();
  const isLoaded = useAppSelector(state => selectIsLoadedMyCards(state, {
    sharingId
  }));
  const isFailure = useAppSelector(state => selectIsFailureMyCards(state, {
    sharingId
  }));
  const isToRefetch = useAppSelector(state => selectIsToRefetchMyCards(state, {
    sharingId
  }));
  const isFetching = useAppSelector(state => selectIsFetchingMyCards(state, {
    sharingId
  }));
  const myActiveCard = useAppSelector(state => selectMyActiveCard(state, {
    sharingId
  }));
  const shouldFetch = (!isLoaded && !isFailure || isToRefetch) && !isFetching;
  useEffect(() => {
    if (!order?.mycard_id && shouldFetch) {
      dispatch(fetchMyCards({
        sharingId
      }));
    }
  }, [dispatch, order?.mycard_id, sharingId, shouldFetch]);
  const offlineMean = useOfflineMean(order);
  const needsSavedCard = isLoaded && !myActiveCard;
  return !offlineMean && !order?.mycard_id && needsSavedCard;
};